export const appsData = {
  pucked: {
    id: "pucked",
    name: "Pucked",
    description: "Smart espresso tracker",
    shortDescription: "Smart espresso tracker",
    iconList: require("../assets/pucked/pucked-icon.png"),
    iconPage: require("../assets/pucked/pucked-icon.png"),
    banner: require("../assets/pucked/pucked-banner.png"),
    screenshots: [
      require("../assets/pucked/screenshot1.png"),
      require("../assets/pucked/screenshot2.png"),
      require("../assets/pucked/screenshot3.png"),
      require("../assets/pucked/screenshot4.png"),
      require("../assets/pucked/screenshot0.png"),
    ],
    appStoreLink:
      "https://apps.apple.com/us/app/pucked-smart-espresso-tracker/id6792107991",
    playStoreLink:
      "https://play.google.com/store/apps/details?id=com.tilboapps.pucked",
    privacyLink: "/pucked/privacy",
    termsLink: "/pucked/terms",
    link: "/pucked",
  },
  sevn: {
    id: "sevn",
    name: "Sevn",
    description: "Simple weekly planner",
    shortDescription: "Simple weekly planner",
    iconList: require("../assets/sevn/sevn-logo.png"),
    iconPage: require("../assets/sevn/sevn-logo-transpa.png"),
    banner: require("../assets/sevn/banner.png"),
    screenshots: [
      require("../assets/sevn/s1.png"),
      require("../assets/sevn/s2.png"),
      require("../assets/sevn/s3.png"),
      require("../assets/sevn/s4.png"),
    ],
    appStoreLink:
      "https://apps.apple.com/us/app/sevn-simple-weekly-planner/id6760269070",
    playStoreLink:
      "https://play.google.com/store/apps/details?id=com.tilboapps.sevn",
    privacyLink: "/sevn/privacy",
    termsLink: "/sevn/terms",
    link: "/sevn",
  },
  milestory: {
    id: "milestory",
    name: "MileStory",
    description:
      "Track your milestones. Celebrate your progress. It's all about the long run.",
    shortDescription: "Track your milestones",
    iconList: require("../assets/milestory/MSLogo.jpg"),
    iconPage: require("../assets/milestory/MSLogo.jpg"),
    banner: require("../assets/milestory/banner.jpg"),
    screenshots: [
      require("../assets/milestory/screenshot1.jpg"),
      require("../assets/milestory/screenshot2.jpg"),
      require("../assets/milestory/screenshot3.jpg"),
      require("../assets/milestory/screenshot4.jpg"),
      require("../assets/milestory/screenshot5.jpg"),
    ],
    appStoreLink:
      "https://apps.apple.com/us/app/milestory-reflect-achieve/id6754716334",
    playStoreLink:
      "https://play.google.com/store/apps/details?id=com.tilboapps.milestory",
    privacyLink: "/milestory/privacy",
    termsLink: "/milestory/terms",
    link: "/milestory",
    xProfile: "https://x.com/MileStoryApp",
  },
};

export const appsList = Object.values(appsData);
